export default "__VITE_ASSET__CwgeBz_A__"